import React, { useEffect, useState } from 'react';
import { NextSeo } from 'next-seo';
import { sample } from 'lodash';
import { Box } from '@chakra-ui/react';
import Mint from 'components/MintPool';
import MintPoolFour from 'components/MintPoolFour';
import MintPoolTwo from 'components/MintPoolTwo';
import { API } from 'config/api';
import withSession from 'lib/session';

const MintPage = ({ data = {}, access_token, user, quantity, id, randomNft }) => {
  console.log('id', id);
  const { name } = data;
  const [collection, setCollection] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.get(`/nft/mintPool/${id}/nonFungibleTokens`).then((res) => {
      setCollection(res.data.data);
      setMeta(res.data.meta);
    });
    API.get(`/nft/mintPool/${id}/transactions`).then((res) => {
      setTransactions(res.data.data);
    });
  }, [id]);

  const paginationHandler = (page) => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
      setLoading(true);
      API.get(`/nft/mintPool/${id}/nonFungibleTokens?page=${page}&limit=9`)
        .then((res) => {
          setCollection(res.data.data);
          setMeta(res.data.meta);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  };
  const url = process.env.NEXT_PUBLIC_URL || 'https://staging.heylayer.com/';
  return (
    <Box id="content" minH="100vh">
      <NextSeo
        title={name}
        description="Try HeyLayer and start your NFT business or grow an existing one. Get more than NFT minting to manage every part of your business."
        openGraph={{
          type: 'website',
          url: url,
          title: `${name}`,
          description: '',
          locale: 'en_EN',
          images: [
            {
              url: randomNft ? randomNft?.file?.thumbnail_http_url : '/images/no_image.jpg',
              width: 800,
              height: 600,
              alt: `${name}`,
            },
          ],
          site_name: 'heylayer.com',
        }}
        twitter={{
          handle: '@HeyLayer',
          site: 'heylayer.com',
          cardType: 'summary_large_image',
        }}
      />

      {id === '4' ? (
        <MintPoolFour
          meta={meta}
          user={user}
          access_token={access_token}
          data={data}
          transactions={transactions}
          queryQuantity={quantity}
          collection={collection ? collection : []}
          onPaginate={paginationHandler}
          isLoading={loading}
        />
      ) : id === '3' ? (
        <MintPoolTwo
          meta={meta}
          user={user}
          access_token={access_token}
          data={data}
          transactions={transactions}
          queryQuantity={quantity}
          collection={collection ? collection : []}
          onPaginate={paginationHandler}
          isLoading={loading}
          mintPool={id}
        />
      ) : id === '2' ? (
        <MintPoolTwo
          meta={meta}
          user={user}
          access_token={access_token}
          data={data}
          transactions={transactions}
          queryQuantity={quantity}
          collection={collection ? collection : []}
          onPaginate={paginationHandler}
          isLoading={loading}
          mintPool={id}
        />
      ) : (
        <Mint
          meta={meta}
          user={user}
          access_token={access_token}
          data={data}
          transactions={transactions}
          queryQuantity={quantity}
          collection={collection ? collection : []}
          onPaginate={paginationHandler}
          isLoading={loading}
        />
      )}
    </Box>
  );
};

export const getServerSideProps = withSession(async function ({ req, params, query }) {
  const user = req.session.get('user');
  const access_token = user?.access_token || '';
  let config = { headers: { Authorization: `Bearer ${access_token}` } };
  try {
    const { id } = params;
    const { quantity } = query;
    // console.log('quantity', quantity);
    const { data } = await API.get(`/nft/mintPool/${id}`, config);
    const resC = await API.get(`/nft/mintPool/${id}/nonFungibleTokens`);
    const randomNft = sample(resC.data.data);
    return {
      props: {
        id,
        quantity: Number(quantity) || 1,
        data: data.data || {},
        randomNft: randomNft || {},
        user: user || {},
        access_token,
      },
    };
  } catch (error) {
    return { notFound: true };
  }
});

export default MintPage;
